import { LoanCriteria, OrderCriteria } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const documentNumberFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.18,
    field: 'documentId',
    sortable: false,
    align: 'left',
    headerName: <Text tId={'DOCUMENT_ID_NUMBER_SHORT'} />,
    renderCell: (rowData: { row: LoanCriteria | OrderCriteria }) => {
      return (
        <div className={'overflow-text-ellipsis'}>
          {rowData.row.borrowerDocumentNumber || rowData.row.borrower?.documentNumber || '-'}
        </div>
      );
    },
  };
};
